var React = require('react');

function Check16x16 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Inverted=off, Size=16x16"},React.createElement("path",{"id":"Vector 199","d":"M2 7l5.5 7L14 2.5","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round"})));
}

Check16x16.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Check16x16;

Check16x16.default = Check16x16;
